import type { SectionBaseModel } from '@/src/components/layout/section/SectionBaseModel';
import { PopupPositionType } from '@/src/typings/interfaces/data/settings/settings';
import type { SectionFrame } from '@/src/components/games/popup/Types';

export const getSectionFrame = (element: Element, model: SectionBaseModel): SectionFrame => {
  const boundingBox = element.getBoundingClientRect();

  let furthestLeft = boundingBox.left;
  let furthestRight = boundingBox.right;
  let furthestTop = boundingBox.top;
  let furthestBottom = boundingBox.bottom;

  element.querySelectorAll<HTMLElement>('.grid__addon').forEach((el) => {
    const bounds = el.getBoundingClientRect();

    if (furthestLeft === undefined || bounds.left < furthestLeft) {
      furthestLeft = bounds.left;
    }

    if (furthestRight === undefined || bounds.right > furthestRight) {
      furthestRight = bounds.right;
    }

    if (furthestTop === undefined || bounds.top < furthestTop) {
      furthestTop = bounds.top;
    }

    if (furthestBottom === undefined || bounds.bottom > furthestBottom) {
      furthestBottom = bounds.bottom;
    }
  });

  const data: SectionFrame = {
    id: model.id,
    position: model.state.config.settings.state.basic?.position?.type ?? PopupPositionType.BOTTOM_LEFT,
    w: furthestRight !== undefined && furthestLeft !== undefined ? Math.abs(furthestRight - furthestLeft) : 0,
    h: furthestBottom !== undefined && furthestTop !== undefined ? Math.abs(furthestBottom - furthestTop) : 0,
    x: model.state.config.settings.state.basic?.position?.x ?? 0,
    y: model.state.config.settings.state.basic?.position?.y ?? 0,
    widthStyle: element instanceof HTMLElement ? element.style.width : '0',
    overlay: !!(
      model.state.config.settings.state.basic?.position?.type === PopupPositionType.CENTER_CENTER ||
      model.state.config.settings.state.basic?.overlay?.enabled
    ),
    boxShadowBlur: model.state.config.settings.state.style?.shadow?.blur ?? 0
  };

  if (model.state.config.settings?.state.basic?.height?.width?.includes('%')) {
    data.widthStyle = model.state.config.settings.state.basic?.height?.width;
  }

  return data;
};
